import { useEffect, useRef, useState } from "react";
import { useGlobalContext } from "src/context/useGlobalContext";
import { messageClientAddress } from "src/endpoints";

const ContactMeForm = () => {

    const { isMobile } = useGlobalContext();
    const [ name, SetName ] = useState('');
	const [ email, SetEmail ] = useState('');
	const [ phoneNumber, SetPhoneNumber ] = useState('');
	const [ message, SetMessage ] = useState('');
	const [ messageSent, SetMessageSent ] = useState(false);
	const [ loading, SetLoading ] = useState(false);
	const [ errorMessage, SetErrorMessage ] = useState('');

	const timer_ref = useRef(new Date().getTime());

	// const componentHasRendered_ref = useRef(false);

	const handleSubmit = async () => {
		try {
			if(messageSent || loading) return;
			if(!name || !email || !phoneNumber || !message) {
				SetErrorMessage('Please fill out all fields')
				return;
			};

			const elapsedTime = new Date().getTime() - timer_ref.current;
			if(elapsedTime < 10 * 1000) {
				SetErrorMessage('Something went wrong, please try again')
				return;
			};

			SetLoading(true);
			SetErrorMessage('');

			const response = await fetch(messageClientAddress, {
				method: "POST",
				headers: {
					'Content-Type': 'application/json',
					// 'Authorization': `Bearer: `
				}, 
				body: JSON.stringify({
					name,
					email,
					phoneNumber,
					message,
				})
			});

			SetLoading(false);
			SetMessageSent(true);

			return response;
		} catch (err) {
			SetLoading(false);
			SetErrorMessage('Error');
			throw new Error(err.message)
		}
	}

	useEffect(() => {
		if(name && email && phoneNumber && message ) {
			SetErrorMessage('');
		}
	}, [name, email, phoneNumber, message])

    return (
        <div className={`w-full lg:w-[700px] px-6 mb-10 flex flex-col lg:flex-row justify-between gap-y-3 lg:gap-x-8`}>
            <div className="flex flex-col w-full lg:w-auto justify-between gap-y-3">
                <input
                    className="px-1 bg-transparent border-b w-full lg:w-[280px] border-gray-400 py-2"
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={(e) => SetName(e.currentTarget.value)}
                />
                <input
                    className="px-1 bg-transparent border-b w-full lg:w-[280px] border-gray-400 py-2"
                    type="text"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => SetEmail(e.currentTarget.value)}
                />
                <input
                    className="px-1 bg-transparent border-b w-full lg:w-[280px] border-gray-400 py-2"
                    type="text"
                    placeholder="Phone number"
                    value={phoneNumber}
                    onChange={(e) => SetPhoneNumber(e.currentTarget.value)}
                />
                {!isMobile && <div className="h-[34px]"></div>}
            </div>

            <div className="lg:w-[445px] flex flex-col">
                <textarea
                    className="bg-transparent border-b border-gray-400 flex-shrink-0 mb-4 py-2 px-2"
                    rows="6"
                    placeholder="Message"
                    value={message}
                    onChange={(e) => SetMessage(e.currentTarget.value)}
                ></textarea>
                <button
                    className={`${
                        !errorMessage ? "bg-orange-500" : "bg-red-800"
                    } py-1 rounded flex justify-center ${
                        loading ? "bg-orange-950" : ""
                    }`}
                    onClick={handleSubmit}
                >
                    {loading ? <span className="loader" /> : ""}
                    {errorMessage
                        ? errorMessage
                        : messageSent
                        ? "Message sent!"
                        : "Send message"}
                </button>
            </div>
        </div>
    );
};

export default ContactMeForm;
